import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Router from "./Router";

const mapStateToProps = (_state) => ({});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Router);
